import React from 'react';
import Hero from '../components/sections/Hero';
import Capabilities from '../components/sections/Capabilities';
import Portfolio from '../components/sections/Portfolio';
import Contact from '../components/sections/Contact';

const Home: React.FC = () => {
  return (
    <main className="main">
      <Hero />
      <Capabilities />
      <Portfolio />
      <Contact />
    </main>
  );
};

export default Home;
